'use strict';

var teamCtrl = ['$http', '$stateParams', 'dialog', 'Department','Member', '$state',"$translate", function($http, $stateParams, dialog, Department, Member, $state, $translate) {
    var _this = this;

    this.removeUser = function(member) {
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_TEAM.DEL_TITLE'),
            body: $translate.instant('DASHBOARD.DASH_TEAM.DEL_BODY',{"email":member.email}),
            accept: $translate.instant('DASHBOARD.DELETE'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(function() {
            Department.removeTeamMember({
                    departmentId: $stateParams.departmentId,
                    teamId: $stateParams.teamId
                }, {
                    id: member.id
                })
                .$promise
                .then(function() {
                    _this.team.members = _this.team.members.filter(function(currentMember) {
                        return member.id !== currentMember.id;
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        });
    };

    this.releaseDevice = function(user) {
                dialog.confirm({
                    title: $translate.instant('DASHBOARD.DASH_TEAM.DESV_TITLE'),
                    body: $translate.instant('DASHBOARD.DASH_TEAM.DESV_BODY',{"userName":  user.firstName + ' ' + user.lastName}),
                    accept: $translate.instant('DASHBOARD.DASH_TEAM.DESV_ACCEPT'),
                    cancel: $translate.instant('DASHBOARD.CANCEL'),
                    size: 'sm'
                }).then(function() {
                    return Member.device.destroyById({
                            fk: user.device[0].id,
                            id: user.id                            
                        }).$promise
                        .then(function() {
                            $state.reload('dashboard');
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                });
            };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            team: '='
        },
        controller: teamCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-team/dashboardTeamDirective.html'
    };
};
